import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closePopup } from '../../actions/uiActions'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import LinearProgress from '@mui/material/LinearProgress';


class LoadingPopup extends React.Component {

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        return (<div className="loaderDialog">
            <Dialog
                open={true}
                maxWidth="sm"
                fullwidth="true"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <div className="loaderIcon">
                        <p>{this.props.popupInfo}</p>
                        <LinearProgress />
                        <span className="cancelPop" onClick={this.handleClick}>Cancel</span>
                    </div>
                </DialogContent>
            </Dialog>
            {/* {x("#77828B", "10px", this.handleClick)}
            <div className="centerBox">
                <br /><br />
                <h2>{this.props.popupInfo}</h2>
                <br /><br />
                <div className="loaderBar"> </div>
                <br /><br /><br /><br />
                <button className="grayButton" onClick={this.handleClick} style={{ 'left': '0px' }} >Cancel</button>
            </div> */}
        </div>)
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadingPopup)